<template>
	<v-radio
		v-bind="$props"
		class="cassie-radio"
		:class="{ 'cassie-radio-reverse-label': reverseLabel }"
		v-on="$listeners"
	/>
</template>

<script>
import { VRadio } from 'vuetify/lib'

export default {
	name: 'radio',
	extends: VRadio,
	props: {
		reverseLabel: Boolean
	}
}
</script>

<style lang="scss">
.cassie-radio {
	&-reverse-label {
		display: flex;
		flex-direction: row-reverse;

		.v-label {
			margin-right: 10px;
		}
	}
}
</style>
